import { render, staticRenderFns } from "./BaseCascader.vue?vue&type=template&id=3cbccd22&scoped=true"
import script from "./BaseCascader.vue?vue&type=script&lang=js"
export * from "./BaseCascader.vue?vue&type=script&lang=js"
import style0 from "./BaseCascader.vue?vue&type=style&index=0&id=3cbccd22&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbccd22",
  null
  
)

export default component.exports